(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairStudentsPhonesController', PhysicalFairStudentsPhonesController);

    PhysicalFairStudentsPhonesController.$inject = ['ExpoService', 'CitiesByExpoService', 'PhysicalFairService','$timeout'];


    function PhysicalFairStudentsPhonesController(ExpoService, CitiesByExpoService, PhysicalFairService, $timeout) {
        var vm = this;


        vm.flag                     = false;
        vm.expo                     = [];
        vm.expoSelected             = [];
        vm.cities                   = [];

        vm.selectExpo               = selectExpo;
        vm.selectCitiesByExpo       = selectCitiesByExpo;
        vm.getByFilter              = getByFilter;
        vm.citySelected             = [];

        vm.downloadCSV              = downloadCSV;

        /* PAGINATION */
        vm.pageChanged = pageChanged;
        vm.setPage = setPage;
        vm.to = [];
        vm.totalItems = [];
        vm.currentPage = null;
        vm.itemsPerPage = [];
        vm.page = 1;

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                    vm.expo = response.data;
            }).catch(function(err) {

            });
        }

        function selectCitiesByExpo () {
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                vm.citySelected          = [];
                vm.cities = response.data;
            }).catch(function(err) {

            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};

            vm.query['expo_id']         = vm.expoSelected.id;
            vm.query['city_id']         = vm.citySelected.id;
            if (vm.page !== null)
                vm.query['page'] = vm.page;

            PhysicalFairService.getStudentsPhones(vm.query).then(function(response){
                vm.response = response.data.data;
                if (vm.response.length === 0) {
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err){

            });
        }

        function setPage(pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged() {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function downloadCSV() {
            vm.query = {};
            vm.query['expo_id']         = vm.expoSelected.id;
            vm.query['city_id']         = vm.citySelected.id;

            PhysicalFairService.getStudentsPhonesCsv(vm.query).success(function (data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = 'student_phones_' + vm.expoSelected.id + '_' + vm.citySelected.id + '.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).error(function (data, status, headers, config) {
                // handle error
            });
        }

        activate();

    }

})();